import { PedidoItemOpcao } from "./PedidoItemOpcao"

export class OpcionaisPedidoAberto {
    pedidoItemId: number = 0
    opcionais: PedidoItemOpcao[] = []
    clienteId?: string | null
}